import React from "react";

function InvoiceRedeemDetails() {
  return <div>InvoiceRedeemDetails</div>;
}

export default InvoiceRedeemDetails;
